/**
 * Coaching staff catalog — static seed + helpers for Firestore `coaches` docs.
 * Same merge pattern as roster: Firestore overlays built-in list; soft-delete via active:false.
 */

import MickeyPhoto from '../assets/images/Mickey.jpg';
import JamesPhoto from '../assets/images/James.jpg';
import JasonPhoto from '../assets/images/Jason.jpg';
import RustyPhoto from '../assets/images/Rusty.jpg';

export const STATIC_COACHES = [
  {
    name: 'Mickey Katz',
    role: 'Head Coach',
    tagline: 'Bench Boss',
    bio: '',
    photoUrl: MickeyPhoto,
    sortOrder: 1,
  },
  {
    name: 'Rusty Nighbert',
    role: 'Team Director',
    tagline: 'Stats Man',
    bio: '',
    photoUrl: RustyPhoto,
    sortOrder: 2,
  },
  {
    name: 'James Otting',
    role: 'Offense Coach',
    tagline: 'The Technician',
    bio: '',
    photoUrl: JamesPhoto,
    sortOrder: 3,
  },
  {
    name: 'Jason Birkle',
    role: 'Defense Coach',
    tagline: 'DJ Big Kid',
    bio: '',
    photoUrl: JasonPhoto,
    sortOrder: 4,
  },
];

export function coachSlug(name) {
  return String(name || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export function coachDocId(nameOrSlug) {
  return coachSlug(nameOrSlug);
}

export function sortCoaches(list) {
  return [...list].sort((a, b) => {
    const sa = Number(a.sortOrder) || 0;
    const sb = Number(b.sortOrder) || 0;
    if (sa !== sb) return sa - sb;
    return String(a.name || '').localeCompare(String(b.name || ''));
  });
}

export function normalizeCoach(raw) {
  const name = String(raw.name || '').trim();
  const slug = String(raw.coachSlug || coachSlug(name)).trim() || coachSlug(name);
  const id = raw.id || slug;
  return {
    id,
    name,
    coachSlug: slug,
    role: String(raw.role || '').trim(),
    tagline: String(raw.tagline || '').trim(),
    bio: typeof raw.bio === 'string' ? raw.bio : '',
    photoUrl: raw.photoUrl || '',
    sortOrder: Number.isFinite(Number(raw.sortOrder)) ? Number(raw.sortOrder) : 0,
    active: raw.active !== false,
  };
}

export function staticCoachesAsDocs() {
  return sortCoaches(
    STATIC_COACHES.map((c, i) =>
      normalizeCoach({
        ...c,
        coachSlug: coachSlug(c.name),
        sortOrder: c.sortOrder ?? i + 1,
      })
    )
  );
}

/** Display line used on home / about cards. */
export function coachRoleLine(coach) {
  const tagline = String(coach.tagline || '').trim();
  const role = String(coach.role || '').trim();
  if (tagline && role) return `${tagline} & ${role}`;
  return tagline || role || '';
}

export function coachWritePayload(fields, { existingSlug } = {}) {
  const name = String(fields.name || '').trim();
  const slug = existingSlug || coachSlug(name);
  return {
    name,
    coachSlug: slug,
    role: String(fields.role || '').trim(),
    tagline: String(fields.tagline || '').trim(),
    bio: String(fields.bio || '').trim(),
    photoUrl: typeof fields.photoUrl === 'string' ? fields.photoUrl : '',
    sortOrder: Number.isFinite(Number(fields.sortOrder)) ? Number(fields.sortOrder) : 0,
    active: fields.active !== false,
  };
}
